import * as moment from 'moment-timezone';
import * as React from 'react';
import { Button, Col, Modal, ModalBody, ModalHeader, Row } from 'reactstrap';
import OpenArrow from 'src/Components/OpenArrow/OpenArrow';
import { IDispatchConfirm, IDispatchTruck } from 'src/Interfaces/DispatchInterface';
import { ReceiveDispatchTable } from './ReceiveDispatchTable';


const boldStyle = {
    fontWeight: 700
};

interface IDispatchReceiveProps {
    dispatch: IDispatchConfirm[] | undefined;
    type: string;
    isOpen: boolean;
    toggleOpen: () => void;
    onReceive: (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => void;
}

export class ReceiveDispatchModal extends React.Component {
    public props: IDispatchReceiveProps;

    public state = {
        dispatchTruckOpen: [] as boolean[][],
    };

    constructor(props: any) {
        super(props);
    }

    private handleTruckOpen = (dispatchIndex: number, index: number) => () => {
        const dispatchTruckOpen = this.state.dispatchTruckOpen;
        if(!Array.isArray(dispatchTruckOpen[dispatchIndex])) {
            dispatchTruckOpen[dispatchIndex] = [];
        }
        dispatchTruckOpen[dispatchIndex][index] = !dispatchTruckOpen[dispatchIndex][index];
        this.setState({dispatchTruckOpen});
    }

    private handleReceive = (dispatchTruck: IDispatchTruck, dispatchIndex: number, truckIndex: number) => () => {
        this.props.onReceive(dispatchTruck, dispatchIndex, truckIndex);
        if (this.props.type !== 'Pick Up') {
        window.open(`/print/dispatchtruckticket/${dispatchTruck.id}/${this.props.type === 'Delivery' ? 'delivery' : 'pickup'}`, '_blank');
        }
    }

    public render() {
        if (!this.props.dispatch) {
            return '';
        }
        const { isOpen, toggleOpen } = this.props;
        const forPending = this.props.type === 'Pending';
        const dispatch = this.props.dispatch;
        return <Modal size="lg" isOpen={isOpen} toggle={toggleOpen} backdrop="static">
            <ModalHeader toggle={toggleOpen}>
                {
                    forPending ?
                    'Pending Dispatches' :
                    `Acknowledge Trucks for ${this.props.type}`
                }
            </ModalHeader>
            <ModalBody>
                {
                    dispatch.filter(d => forPending || d.status === 'Confirmed').map((d, dind) => <Row style={{marginBottom: '1rem'}} key={d.id}>
                    <Col>
                    <Row>
                        <Col>
                            <h3 style={boldStyle}>Submitted Test Date:</h3>
                        </Col>
                        <Col>
                            <h3>
                                { 
                                d.submittedWellTest
                                ? moment.unix(d.submittedWellTest.testDate).format("MMM DD YYYY")
                                : ( d.type === 'Pickup' ? 'Automatic Pickup' : 'Spud Load' )}
                            </h3>
                        </Col>
                    </Row>
                    {
                        forPending &&
                        <Row>
                            <Col>
                                <h3 style={boldStyle}>{d.type}</h3>
                            </Col>
                        </Row>
                    }
                    {
                        d.trucks.map((dt, index) => 
                        <React.Fragment key={dt.id === '' ? index : dt.id}>
                            <h4 style={boldStyle}>
                                <Row>
                                    <Col>
                                            <span onClick={this.handleTruckOpen(dind, index)}>
                                                <OpenArrow open={this.state.dispatchTruckOpen[dind] && this.state.dispatchTruckOpen[dind][index]} />
                                                Truck {dt.ordinal}:
                                                {' '}
                                                Current Status: {dt.status ? dt.status : d.status}
                                                {' '}
                                            </span>
                                            
                                    </Col>
                                    {
                                        !forPending && this.props.type === "Delivery" && dt.status === 'EnRoute' &&
                                        <Col>
                                            <Button color="primary" onClick={this.handleReceive(dt, dind, index)}>Receive Truck</Button>
                                        </Col>
                                    }
                                    {
                                        !forPending && this.props.type === "Pick Up" && !dt.returnedWellTestId && !dt.returnedWellCloseReviewId &&
                                        <Col>
                                            <Button color="primary" onClick={this.handleReceive(dt, dind, index)}>Acknowledge Pickup</Button>
                                        </Col>
                                    }
                                </Row>
                            </h4>
                            {
                                this.state.dispatchTruckOpen[dind] && this.state.dispatchTruckOpen[dind][index] && 
                                <Row>
                                    <Col>
                                        <ReceiveDispatchTable dispatchTruck={dt} />
                                    </Col>
                                </Row>
                            }
                        </React.Fragment>
                        )
                    }
                    </Col>
                    </Row>
                    )
                }
            </ModalBody>
        </Modal>;
    }

}


// WEBPACK FOOTER //
// ./src/Components/Main/Dispatch/ReceiveDispatch/ReceiveDispatchModal.tsx